import { TReportsRequestParams } from "domain/repositories/reports-repository";

export const checkParamsConsoleOnly = (params: TReportsRequestParams) =>
  !params.PortfolioId;

export const checkParamsFromPortfolio = (params: TReportsRequestParams) =>
  params.PortfolioId;

export const checkParamsPortfolioOnly = (params: TReportsRequestParams) =>
  params.PortfolioId && !params.CampaignId;

export const checkParamsCampaignOnly = (params: TReportsRequestParams) =>
  params.CampaignId && !params.CreativeId;

export const checkParamsFromCreative = (params: TReportsRequestParams) =>
  params.CreativeId;

export const checkParamsCreativeOnly = (params: TReportsRequestParams) =>
  params.CreativeId && !params.UrlId;
